const SafetyIconVerticalLifting = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M26 21C25.9704 20.0168 25.8711 19.3897 25.5348 18.855C25.056 18.0937 24.1946 17.67 22.4724 16.824L20.8711 16.0365C19.4652 15.3457 18.7622 15 18.0064 15C17.2506 15 16.5476 15.345 15.1417 16.0365L13.5404 16.824C11.8183 17.67 10.9568 18.0937 10.478 18.855C10 19.6155 10 20.5628 10 22.4565V22.5443C10 24.4372 10 25.3845 10.478 26.145C10.9568 26.9063 11.8183 27.33 13.5404 28.1768L15.1417 28.9635C16.5476 29.6543 17.2506 30 18.0064 30C18.7622 30 19.4652 29.655 20.8711 28.9635L22.4724 28.176C24.1946 27.3293 25.056 26.9063 25.5348 26.145C25.8711 25.6103 25.9704 24.9832 26 24M25.2122 19.125L22.0096 20.625M22.0096 20.625L21.6093 20.8125L18.0064 22.5M22.0096 20.625V23.25M22.0096 20.625L14.4035 16.875M18.0064 22.5L10.8006 19.125M18.0064 22.5V29.625"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.25 13.1111C17.25 13.5253 17.5858 13.8611 18 13.8611C18.4142 13.8611 18.75 13.5253 18.75 13.1111H17.25ZM18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L12.6967 10.2426C12.4038 10.5355 12.4038 11.0104 12.6967 11.3033C12.9896 11.5962 13.4645 11.5962 13.7574 11.3033L18 7.06066L22.2426 11.3033C22.5355 11.5962 23.0104 11.5962 23.3033 11.3033C23.5962 11.0104 23.5962 10.5355 23.3033 10.2426L18.5303 5.46967ZM18.75 13.1111V6H17.25V13.1111H18.75Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIconVerticalLifting
